<style scoped>
.out_group_sensor {
  display: block;
  padding: 20px;
  border-bottom: 1px solid rgb(62, 86, 110);
}

.out_group_sensor .sensor-name-block,
.out_group_sensor .sensor-serial-number-block {
  display: inline-block;
  width: 40%;
  font-size: 20px;
}

.out_group_sensor a {
  text-decoration: none;
  color: inherit;
}

.out_group_sensor.out-group-sensor-new {
  box-shadow: inset 0px -40px 30px -40px rgb(0, 255, 34)
}

.out_group_sensor .icon {
  background-color: white;
  background-size: 100%;
  height: 20px;
  width: 20px;
  float: left;
  /* margin: 3px 7px; */
}

.out_group_sensor .sensor-serial-number-block {
    color: rgb(62, 86, 110);
}
</style>

<template>
<div class="out_group_sensor col-12" :class="{'out-group-sensor-new': sensorNew}">
  <div class="sensor-name-block">
    <div class="name-block">
      <router-link :to="{ name: 'sensor-settings', params: { id_group: id_group, id_sensor: sensor.id_sensor }}">
        {{sensorName}}
      </router-link>
    </div>
  </div>
  <div class="sensor-serial-number-block">
    ID {{sensorSerial}}
  </div>
  <div class="sensor-del-block">
    <b-btn class="icon cancel" :id="nameDelButtton" @click="del_popover = !del_popover"></b-btn>
  </div>
  <b-popover :show.sync="del_popover" :target="nameDelButtton" title="Удалить этот датчик" class="faucet-del-popover">
    <button type="button" class="btn btn-outline-danger" @click="deleteSensor">Да</button>
    <button type="button" @click="onCloseDelPopover" class="btn btn-outline-info">Нет</button>
  </b-popover>
</div>
</template>

<script>
import config from '@/config.js'
import axios from 'axios'
import {
  store
} from '@/store'

export default {
  name: 'out-group-sensor-row',
  data() {
    return {
      show: false,
      del_popover: false,
      id_group: this.$store.getters.id_group
    }
  },
  props: {
    sensor: Object
  },
  methods: {
    onCloseDelPopover() {
      this.del_popover = false
    },
    deleteSensor() {
      if (!!localStorage.token) {
        var post_data = new FormData()
        post_data.set('token', localStorage.token)
        post_data.set('id_sensor', this.sensor.id_sensor)
        var vue_obj = this
        axios({
            method: 'POST',
            url: config.API_HOST + '/sensors/delete_sensor',
            data: post_data
          })
          .then(function (response) {
            vue_obj.$emit('deleteRow')
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    }
  },
  computed: {
    nameDelButtton: function () {
      return 'delSensor-' + this.sensor.id_sensor
    },
    sensorName: function () {
      return this.sensor.name
    },
    sensorSerial: function () {
        var serial_number = this.sensor.serial_number.split("-").join("")
        serial_number = serial_number.toUpperCase()
        if (serial_number.length > 0) {
            serial_number = serial_number.match(new RegExp('.{1,4}', 'g')).join("-")
        }
        return serial_number
    },
    sensorNew: function () {
      return this.sensor.new
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/out_group_sensor_row.vue